import React from "react";

const EvenRow = () => (
  <div className="t-flex t-justify-between t-items-center t-border t-border-solid t-border-t-0 t-border-l-0 t-border-r-0 t-border-neutral-0 t-py-2 t-px-4">
    <div className="t-flex t-gap-2 t-items-center t-w-full">
      <div className="t-relative t-h-8 t-w-1/5 t-rounded-lg t-flex t-items-center t-justify-center t-bg-neutral-20 t-animate-pulse"></div>
      <div className="t-relative t-h-8 t-w-20 t-rounded-lg t-flex t-items-center t-justify-center t-bg-neutral-20 t-animate-pulse"></div>
      <div className="t-relative t-h-8 t-w-1/5 t-rounded-lg t-flex t-items-center t-justify-center t-bg-neutral-20 t-animate-pulse"></div>
      <div className="t-relative t-h-8 t-w-20 t-rounded-lg t-flex t-items-center t-justify-center t-bg-neutral-20 t-animate-pulse"></div>
      <div className="t-relative t-h-8 t-w-1/5 t-rounded-lg t-flex t-items-center t-justify-center t-bg-neutral-20 t-animate-pulse"></div>
      <div className="t-relative t-h-8 t-w-1/5 t-rounded-lg t-flex t-items-center t-justify-center t-bg-neutral-20 t-animate-pulse"></div>
    </div>
    <div className="t-relative t-h-8 t-w-20 t-rounded-lg t-flex t-items-center t-justify-center t-bg-neutral-20 t-animate-pulse"></div>
  </div>
);

const OddRow = () => (
  <div className="t-flex t-border t-border-solid t-border-t-0 t-border-l-0 t-border-r-0 t-border-neutral-0 t-py-2 t-px-4 t-gap-2 t-items-center t-w-full">
    <div className="t-relative t-h-8 t-w-20 t-rounded-lg t-flex t-items-center t-justify-center t-bg-neutral-20 t-animate-pulse"></div>
    <div className="t-relative t-h-8 t-w-1/5 t-rounded-lg t-flex t-items-center t-justify-center t-bg-neutral-20 t-animate-pulse"></div>
    <div className="t-relative t-h-8 t-w-20 t-rounded-lg t-flex t-items-center t-justify-center t-bg-neutral-20 t-animate-pulse"></div>
    <div className="t-relative t-h-8 t-w-1/5 t-rounded-lg t-flex t-items-center t-justify-center t-bg-neutral-20 t-animate-pulse"></div>
    <div className="t-relative t-h-8 t-w-20 t-rounded-lg t-flex t-items-center t-justify-center t-bg-neutral-20 t-animate-pulse"></div>
    <div className="t-relative t-h-8 t-w-1/5 t-rounded-lg t-flex t-items-center t-justify-center t-bg-neutral-20 t-animate-pulse"></div>
    <div className="t-relative t-h-8 t-w-20 t-rounded-lg t-flex t-items-center t-justify-center t-bg-neutral-20 t-animate-pulse"></div>
    <div className="t-relative t-h-8 t-w-1/5 t-rounded-lg t-flex t-items-center t-justify-center t-bg-neutral-20 t-animate-pulse"></div>
  </div>
);

export const Task1120Loader = () => {
  return (
    <div className="t-py-4 t-px-2" data-testid="loader-todolist">
      <EvenRow />
      <OddRow />
      <EvenRow />
      <OddRow />
      <EvenRow />
      <OddRow />
      <EvenRow />
      <OddRow />
      <EvenRow />
      <OddRow />
      <EvenRow />
    </div>
  );
};
